import { safeLazy as lazy } from './safeLazy';
import { Navigate } from 'react-router';
import useAuth from 'hooks/useAuth';
// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';
import ProtectedUserRoute from './ProtectedUserRoute';

const CreateProduct = Loadable(lazy(() => import('pages/product/create-product')));
const ViewProduct = Loadable(lazy(() => import('pages/product/view-product')));
const DraftProduct = Loadable(lazy(() => import('pages/product/draft-product')));

const CreateBankUser = Loadable(lazy(() => import('pages/bank-user/create-bank-user/index.jsx')));
const ViewBankUser = Loadable(lazy(() => import('pages/bank-user/view-bank-user')));
const DraftBankUser = Loadable(lazy(() => import('pages/bank-user/draft-bank-user')));

const CreateCustomer = Loadable(lazy(() => import('pages/customer/create-customer/index.jsx')));
const CreatePmAdmin = Loadable(lazy(() => import('pages/pm-admin/create-pm-admin/index.jsx')));
const ViewPmAdmin = Loadable(lazy(() => import('pages/pm-admin/view-pm-admin')));
const DraftPmAdmin = Loadable(lazy(() => import('pages/pm-admin/draft-pm-admin')));
const CreateCorpAdmin = Loadable(lazy(() => import('pages/corp-admin/create-corp-admin/index.jsx')));
const CreateProgramManager = Loadable(lazy(() => import('pages/program-manager/create-program-manager/index.jsx')));
const DraftProgramManager = Loadable(lazy(() => import('pages/program-manager/draft-program-manager')));
const CreateCorparate = Loadable(lazy(() => import('pages/corporate/create-corp/index.jsx')));
const DraftCorporate = Loadable(lazy(() => import('pages/corporate/draft-corp')));
const CreateBin = Loadable(lazy(() => import('pages/bin/create-bin')));
const ViewBin = Loadable(lazy(() => import('pages/bin/view-bin')));
const AssignBin = Loadable(lazy(() => import('pages/bin/assign-bin')));
const ViewAssignBin = Loadable(lazy(() => import('pages/bin/view-assign-bin')));

const PayUser = Loadable(lazy(() => import('pages/wallet/pay-user')));
const AddBalance = Loadable(lazy(() => import('pages/wallet/add-balance')));
const WalletReport = Loadable(lazy(() => import('pages/wallet/wallet-report')));
const WalletSetting = Loadable(lazy(() => import('pages/wallet/wallet-setting')));
const ViewWalletLimits = Loadable(lazy(() => import('pages/wallet/view-wallet-limits')));
const OriginManage = Loadable(lazy(() => import('pages/origin-manage/origin-manage')));
const FeatureMapping = Loadable(lazy(() => import('pages/feature-mapping/feature-mapping')));
const ApiPartnerMapping = Loadable(lazy(() => import('pages/api-partner/api-partner')));
const AddEmbossa = Loadable(lazy(() => import('pages/embossa/add-embossa')));
const EmbossaReport = Loadable(lazy(() => import('pages/embossa/embossa-report')));

// Corp Admin
const ViewCorpAdmin = Loadable(lazy(() => import('pages/corp-admin/view-corp-admin')));
const ViewDraftRequestCorpAdmin = Loadable(lazy(() => import('pages/corp-admin/draft-corp-admin')));

//Page Lazy loading
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const CardTemplate = Loadable(lazy(() => import('pages/card-template/view-template')));
const Profile = Loadable(lazy(() => import('pages/profile')));
const Dashboard = Loadable(lazy(() => import('pages/dashboard')));
const AllCards = Loadable(lazy(() => import('pages/cards/all-cards')));
const CardDetails = Loadable(lazy(() => import('pages/cards/card-details')));
const BuyCards = Loadable(lazy(() => import('pages/inventory/buy-cards/index.jsx')));
const MyOrders = Loadable(lazy(() => import('pages/inventory/myorders')));
const CardShipping = Loadable(lazy(() => import('pages/inventory/card-shipping')));
const ShippingReport = Loadable(lazy(() => import('pages/inventory/shipping-report')));


const PersoNonPersoReport = Loadable(lazy(() => import('pages/inventory/nonperso-perso-report')));
const TransferCardDetails = Loadable(lazy(() => import('pages/inventory/transfer-card-details')));
const TransferCard = Loadable(lazy(() => import('pages/inventory/transfer-card')));


const ViewDepartment = Loadable(lazy(() => import('pages/master/view-department')));
const ViewRole = Loadable(lazy(() => import('pages/master/view-role')));
const ViewDesignation = Loadable(lazy(() => import('pages/master/view-designation')));
const ViewBranch = Loadable(lazy(() => import('pages/master/view-branch')));
const CreateDepartment = Loadable(lazy(() => import('pages/master/create-department')));
const CreateRole = Loadable(lazy(() => import('pages/master/create-role')));
const CreateDesignation = Loadable(lazy(() => import('pages/master/create-designation')));
const CreateBranch = Loadable(lazy(() => import('pages/master/create-branch')));
const MapDepartment = Loadable(lazy(() => import('pages/master/map-department')));
const MapRole = Loadable(lazy(() => import('pages/master/map-role')));

const AllTickets = Loadable(lazy(() => import('pages/customer-support/all-tickets')));
const TicketDetails = Loadable(lazy(() => import('pages/customer-support/ticket-details')));
const RaiseQuery = Loadable(lazy(() => import('pages/customer-support/raise-query')));

const ViewProgramManager = Loadable(lazy(() => import('pages/program-manager/view-program-manager')));
const InventoryReport = Loadable(lazy(() => import('pages/inventory/inventory-report')));

const ViewCorporate = Loadable(lazy(() => import('pages/corporate/view-corp')));
const DraftCustomer = Loadable(lazy(() => import('pages/customer/draft-customer')));
const ViewBranchReport = Loadable(lazy(() => import('pages/inventory/branch-report')));
const ViewVirtualToPhysical = Loadable(lazy(() => import('pages/inventory/virtual-to-physical-report')));
const ViewStockDetails = Loadable(lazy(() => import('pages/inventory/stock/view-stock')));
const ChangePassword = Loadable(lazy(() => import('pages/change-password/change-password')));

const ReportCenter = Loadable(lazy(() => import('pages/report-center/report-center')));
const OnboardingReport = Loadable(lazy(() => import('pages/report-center/onboarding-report')));

const BulkCustomer = Loadable(lazy(() => import('pages/customer/bulk-customer')));
const BulkLoad = Loadable(lazy(() => import('pages/cards/bulk-load')));
const BulkPinSet = Loadable(lazy(() => import('pages/cards/bulk-pin-set')));
const BulkLoadReport = Loadable(lazy(() => import('pages/cards/bulk-load-report')));
const BulkPinSetReport = Loadable(lazy(() => import('pages/cards/bulk-pin-set-report')));
const BulkCustomerReport = Loadable(lazy(() => import('pages/customer/bulk-customer-report')));

const CardPendingRequest = Loadable(lazy(() => import('../pages/inventory/akiko-card-request')));

const NotFoundRedirect = () => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Navigate to="/maintenance/404" replace /> : <Navigate to="/login" replace />;
};

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'dashboard',
          element: <Dashboard />
        },
        {
          path: 'profile',
          element: <Profile />
        },
        {
          path: 'all-cards',
          element: <AllCards />
        },

        {
          path: 'view-department',
          element: <ViewDepartment />
        },
        {
          path: 'view-role',
          element: <ViewRole />
        },
        {
          path: 'view-designation',
          element: <ViewDesignation />
        },
        {
          path: 'view-branch',
          element: <ViewBranch />
        },
        {
          path: 'create-department',
          element: <CreateDepartment />
        },
        {
          path: 'create-role',
          element: <CreateRole />
        },
        {
          path: 'create-designation',
          element: <CreateDesignation />
        },
        {
          path: 'create-branch',
          element: <CreateBranch />
        },
        {
          path: 'map-department',
          element: <MapDepartment />
        },
        {
          path: 'map-role',
          element: <MapRole />
        },
        {
          path: 'create-product',
          element: <CreateProduct />
        },
        {
          path: 'view-product',
          element: <ViewProduct />
        },
        {
          path: 'draft-product',
          element: <DraftProduct />
        },
        {
          path: 'product/pending-product',
          element: <ViewProduct />
        },
        {
          path: 'product/change-request',
          element: <ViewProduct />
        },
        {
          path: 'create-bank-user',
          element: <CreateBankUser />
        },
        {
          path: 'view-bank-user',
          element: <ViewBankUser />
        },
        {
          path: 'draft-bank-user',
          element: <DraftBankUser />
        },
        {
          path: 'create-customer',
          element: <CreateCustomer />
        },
        {
          path: 'create-pm-admin',
          element: <CreatePmAdmin />
        },
        {
          path: 'view-pm-admin',
          element: <ViewPmAdmin />
        },
        {
          path: 'draft-pm-admin',
          element: <DraftPmAdmin />
        },
        {
          path: 'pm-admin-request',
          element: <ViewPmAdmin />
        },
        {
          path: 'pm-admin-change-request',
          element: <ViewPmAdmin />
        },
        {
          path: 'create-corp-admin',
          element: <CreateCorpAdmin />
        },
        {
          path: 'view-corp-admin',
          element: <ViewCorpAdmin />
        },
        {
          path: 'draft-corp-admin',
          element: <ViewDraftRequestCorpAdmin />
        },
        {
          path: 'corp-admin-request',
          element: <ViewCorpAdmin />
        },
        {
          path: 'corp-admin-change-request',
          element: <ViewCorpAdmin />
        },
        {
          path: 'create-pm',
          element: <CreateProgramManager />
        },
        {
          path: 'draft-pm',
          element: <DraftProgramManager />
        },
        {
          path: 'create-corp',
          element: <CreateCorparate />
        },
        {
          path: 'draft-corp',
          element: <DraftCorporate />
        },
        {
          path: 'create-bin',
          element: <CreateBin />
        },
        {
          path: 'view-bin',
          element: <ViewBin />
        },
        {
          path: 'assign-bin',
          element: <AssignBin />
        },
        {
          path: 'view-assign-bin',
          element: <ViewAssignBin />
        },
        {
          path: 'pay-user',
          element: <PayUser />
        },
        {
          path: 'add-balance',
          element: <AddBalance />
        },
        {
          path: 'wallet-report',
          element: <WalletReport />
        },
        {
          path: 'wallet-setting',
          element: <WalletSetting />
        },
        {
          path: 'view-wallet-limits',
          element: <ViewWalletLimits />
        },
        {
          path: 'origin-manage',
          element: <OriginManage />
        },
        {
          path: 'feature-mapping',
          element: <FeatureMapping />
        },
        {
          path: 'api-partner',
          element: <ApiPartnerMapping />
        },
        {
          path: 'card-template/view-tepmlate',
          element: <CardTemplate />
        },
        {
          path: 'add-embossa',
          element: <AddEmbossa />
        },
        {
          path: 'embossa-report',
          element: <EmbossaReport />
        },
        {
          path: 'card-details',
          element: <CardDetails />
        },
        {
          path: 'buy-cards',
          element: <BuyCards />
        },
        {
          path: 'my-orders',
          element: <MyOrders />
        },
        {
          path: 'card-shipping',
          element: <CardShipping />
        },
        {
          path: 'bulk-customer',
          element: <BulkCustomer />
        },
        {
          path: 'shipping-report',
          element: <ShippingReport />
        },
        {
          path: 'nonperso-perso-report',
          element: <PersoNonPersoReport />
        },
        {
          path: 'perso-report',
          element: <PersoNonPersoReport />
        },
        {
          path: 'transfer-card-details',
          element: <TransferCardDetails />
        },
        {
          path: 'transfer-card',
          element: <TransferCard />
        },
        {
          path: 'all-tickets',
          element: <AllTickets />
        },
        {
          path: 'ticket-details',
          element: <TicketDetails />
        },
        {
          path: 'raise-query',
          element: <RaiseQuery />
        },
        {
          path: 'view-pm',
          element: <ViewProgramManager />
        },
        {
          path: 'inventory/pm-admin-request',
          element: <InventoryReport />
        },
        {
          path: 'inventory/pm-admin-view',
          element: <InventoryReport />
        },
        {
          path: 'inventory/corp-admin-request',
          element: <InventoryReport />
        },
        {
          path: 'inventory/corp-admin-view',
          element: <InventoryReport />
        },
        {
          path: 'inventory/pm-request',
          element: <InventoryReport />
        },
        {
          path: 'inventory/pm-view',
          element: <InventoryReport />
        },
        {
          path: 'inventory/corp-request',
          element: <InventoryReport />
        },
        {
          path: 'inventory/corp-view',
          element: <InventoryReport />
        },
        {
          path: 'view-corp',
          element: <ViewCorporate />
        },
        {
          path: 'draft-customer',
          element: <DraftCustomer />
        },
        {
          path: 'view-card',
          element: <ViewVirtualToPhysical />
        },
        {
          path: 'view-stock',
          element: <ViewStockDetails />
        },
        {
          path: 'virtual-to-physical/request',
          element: <ViewVirtualToPhysical />
        },
        {
          path: 'virtual-to-physical/report',
          element: <ViewVirtualToPhysical />
        },
        {
          path: 'branch-report',
          element: <ViewBranchReport />
        },

        {
          path: 'change-password',
          element: <ChangePassword />
        },
        {
          path: 'reports/admin-report',
          element: <ReportCenter />
        },
        {
          path: 'reports/onboarding-report',
          element: <OnboardingReport />
        },
        {
          path: 'bulk-load',
          element: <BulkLoad />
        },
        {
          path: 'bulk-load-report',
          element: <BulkLoadReport />
        },
        {
          path: 'bulk-pin-set',
          element: <BulkPinSet />
        },
        {
          path: 'bulk-pin-set-report',
          element: <BulkPinSetReport />
        },
        {
          path: 'bulk-customer-report',
          element: <BulkCustomerReport />
        },
        {
          path: "card-request/request",
          element: (
            <ProtectedUserRoute>
              <CardPendingRequest />
            </ProtectedUserRoute>
          ),
        },
        {
          path: "card-request/report",
          element: (
            <ProtectedUserRoute>
              <CardPendingRequest />
            </ProtectedUserRoute>
          ),
        },
      ]
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        },

      ]
    },
    {
      path: '*',
      element: <NotFoundRedirect />
    }
  ]
};

export default MainRoutes;
